import React from "react";
import {useCopyClipboard} from "../../utils/helpers";
import {Link} from "react-router-dom";
import {useMyContext} from "../../context/MyContext";
const CodeBlock = ({headers, path, methodType, currMethod}) => {
  const {copyStatus, handleCopyClipboard} = useCopyClipboard();
  const headersValue = headers?.reduce(
    (acc, item) => {
      const {name, type} = item;
      return {
        ...acc,
        [name]: type,
      };
    },
    {"Content-type": "application/json", "Accept": "application/json"},
  );

  // eslint-disable-next-line no-undef
  const domainPathUrl = process.env.REACT_APP_DOMAIN_PATH ?? "https://api-dev.phenompeople.com";

  const params = {
    url: `${domainPathUrl}${path}`,
    method: methodType,
    headers: headersValue,
  };
  // eslint-disable-next-line new-cap
  // const curlResponse = CurlGenerator(params);
  const {setShowTryOut, setMethod, setPath} = useMyContext();
  const openTryOut =()=>{
    setPath(path);
    setMethod(currMethod);
    setShowTryOut(true);
  };

  const generateCurlCommand = ({url, method, headers}) => {
    const headerStrings = headers && Object.entries(headers).map(
      ([key, value]) => `-H '${key}: ${value}'`,
    );
    const curlCommand = `curl -X ${method?.toUpperCase()} ${url} \n${headerStrings?.join(
      " \n",
    )}`;
    return curlCommand;
  };
  const curlResponse = generateCurlCommand(params);

  return (
    <div className="method-example-part example-request">
      <div className="dark-box">
        <div className="lang-selector">
          <Link className="active">shell</Link>
        </div>
      </div>
      <div className="highlight">
        <pre className="highlight shell">
          <div
            className="copy-clipboard"
            onClick={() => handleCopyClipboard(curlResponse)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <title>Copy to Clipboard</title>
              <path d="M18 6v-6h-18v18h6v6h18v-18h-6zm-12 10h-4v-14h14v4h-10v10zm16 6h-14v-14h14v14z"></path>
            </svg>
            <span id={copyStatus ? "codeblock-active" : "custom-tooltip"}>copied!</span>
          </div>
          <span className="c"># You can also use wget</span>
          <code style={{color: "#fff", paddingBottom: "1rem"}}>
            {curlResponse}
          </code>
        </pre>
      </div>
      <div className="tryout-container">
        <button className="tryOut-btn" onClick={openTryOut}>
          Try Out
        </button>
      </div>
    </div>
  );
};
export default CodeBlock;
